import { requestCDN } from "../../apis";
import localStorageKey from "../../enumerations/localStorageKey";

const defaultCurrency =
  localStorage.getItem(localStorageKey.DEFAULT_CURRENCY) || process.env.REACT_APP_DEFAULT_CURRENCY;

export const apiGetTGLink = (params) => {
  const millis = Date.now();
  return requestCDN("get", `/${defaultCurrency?.toUpperCase()}/telegramservice.json?v=${millis}`);
  // return requestMain("get", `/${defaultCurrency}/telegramservice`, params, false, false);
};
